<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteUser">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">


                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Profil Resmi:</label>
                                <div class="col-lg-10">
                                    <div class="col-lg-9 col-xl-6">
                                    <div class="image-input image-input-outline" id="kt_profile_avatar">
                                        <!-- BACKGROUND yerine IMG -->
                                        <img
                                        v-if="photo"
                                        :src="photo"
                                        alt="Profil resmi"
                                        class="avatar-img"
                                        draggable="true"
                                        />

                                        <label
                                        class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                        data-action="change"
                                        data-toggle="tooltip"
                                        :title="'Profil resmini değiştir'"
                                        >
                                        <i class="fa fa-pen icon-sm text-muted"></i>
                                        <input
                                            type="file"
                                            name="profile_avatar"
                                            accept=".png, .jpg, .jpeg"
                                            @change="onFileChange($event)"
                                        />
                                        <input type="hidden" name="profile_avatar_remove" />
                                        <input ref="id" type="hidden" :value="user.id" />
                                        </label>

                                        <span class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                            data-action="cancel" data-toggle="tooltip" title="İptal">
                                        <i class="ki ki-bold-close icon-xs text-muted"></i>
                                        </span>

                                        <span class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                            data-action="remove" data-toggle="tooltip" title="Profil resmini kaldır"
                                            @click="current_photo = null">
                                        <i class="ki ki-bold-close icon-xs text-muted"></i>
                                        </span>
                                    </div>

                                    <!-- İsteğe bağlı: direkt indirme butonu -->
                                    <a v-if="photo"
                                        :href="photo"
                                        :download="`user_${user.id}.jpg`"
                                        class="btn btn-sm btn-light mt-2">
                                        İndir
                                    </a>

                                    <span class="form-text text-muted">İzin verilen resim türleri: png, jpg, jpeg.</span>
                                    </div>
                                </div>
                            </div>


                            
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">İsim Soyisim:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">E-Posta:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.email">
                                    <div v-if="errors.email" :errors="errors">
                                        <b-badge v-for="error in errors.email" class="mr-1" :key="error.email" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Doğum Tarihi:</label>
                                <div class="col-lg-10">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.date_of_birth">
                                    <div v-if="errors.date_of_birth" :errors="errors">
                                        <b-badge v-for="error in errors.date_of_birth" class="mr-1" :key="error.date_of_birth" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Doğum Yeri:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.birth_place">
                                    <div v-if="errors.birth_place" :errors="errors">
                                        <b-badge v-for="error in errors.birth_place" class="mr-1" :key="error.birth_place" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Bölge:</label>
                                <div class="col-lg-10">
                                    <select class="form-control" v-model="user.region" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="region in regions" :value="region" :key="region">{{ region }}</option>
                                    </select>
                                    <div v-if="errors.region" :errors="errors">
                                        <b-badge v-for="error in errors.region" class="mr-1" :key="error.region" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Meslek:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.job">
                                    <div v-if="errors.job" :errors="errors">
                                        <b-badge v-for="error in errors.job" class="mr-1" :key="error.job" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kan Grubu:</label>
                                <div class="col-lg-10">
                                    <select class="form-control" v-model="user.blood_group" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="blood_group in blood_groups" :value="blood_group" :key="blood_group">{{ blood_group }}</option>
                                    </select>
                                    <div v-if="errors.blood_group" :errors="errors">
                                        <b-badge v-for="error in errors.blood_group" class="mr-1" :key="error.blood_group" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Cep Telefonu:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.mobile_phone">
                                    <div v-if="errors.mobile_phone" :errors="errors">
                                        <b-badge v-for="error in errors.mobile_phone" class="mr-1" :key="error.mobile_phone" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Ev Telefonu:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.home_phone">
                                    <div v-if="errors.home_phone" :errors="errors">
                                        <b-badge v-for="error in errors.home_phone" class="mr-1" :key="error.home_phone" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Adres:</label>
                                <div class="col-lg-10">
                                    <textarea class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.address"></textarea>
                                    <div v-if="errors.address" :errors="errors">
                                        <b-badge v-for="error in errors.address" class="mr-1" :key="error.address" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Üye No:</label>
                                <div class="col-lg-10">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.member_no">
                                    <div v-if="errors.member_no" :errors="errors">
                                        <b-badge v-for="error in errors.member_no" class="mr-1" :key="error.member_no" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Üyelik Yılı:</label>
                                <div class="col-lg-10">
                                    <select class="form-control" v-model="user.member_year" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="member_year in member_years" :value="member_year" :key="member_year">{{ member_year }}</option>
                                    </select>
                                    <div v-if="errors.member_year" :errors="errors">
                                        <b-badge v-for="error in errors.member_year" class="mr-1" :key="error.member_year" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Durumu:</label>
                                <div class="col-lg-10">
                                    <select class="form-control" v-model="user.member_status" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="member_status in member_statuses" :value="member_status" :key="member_status">{{ member_status }}</option>
                                    </select>
                                    <div v-if="errors.member_status" :errors="errors">
                                        <b-badge v-for="error in errors.member_status" class="mr-1" :key="error.member_status" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Üyelik Yenileme Zamanı:</label>
                                <div class="col-lg-10">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.membership_renews_at">
                                    <div v-if="errors.membership_renews_at" :errors="errors">
                                        <b-badge v-for="error in errors.membership_renews_at" class="mr-1" :key="error.membership_renews_at" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Şifre:</label>
                                <div class="col-lg-10">
                                    <input type="password" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.password">
                                    <div v-if="errors.password" :errors="errors">
                                        <b-badge v-for="error in errors.password" class="mr-1" :key="error.password" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Şifre Tekrar:</label>
                                <div class="col-lg-10">
                                    <input type="password" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="user.password_confirmation">
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kullanıcı Grupları:</label>
                                <div class="col-lg-10">
                                    <multiselect 
                                        v-model="user.roles"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="roles" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="name"
                                        @search-change="findByRoleName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.roles" :errors="errors">
                                        <b-badge v-for="error in errors.roles" class="mr-1" :key="error.roles" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">İzinler:</label>
                                <div class="col-lg-10">
                                    <multiselect 
                                        v-model="user.permissions"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="permissions" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="id"
                                        @search-change="findByPermissionName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.permissions" :errors="errors">
                                        <b-badge v-for="error in errors.permissions" class="mr-1" :key="error.permissions" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Üyelik Statüsü:</label>
                                <div class="col-lg-10">
                                    <b-badge class="mr-1" :variant="getClass(user.status)" v-if="user.status">
                                        <h4>{{ user.status }}</h4>
                                    </b-badge>
                                    
                                </div>
                            </div>
                           
                           
                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-10">
                                        {{ user.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-10">
                                        <span>{{ user.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-10">
                                        {{ user.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-10">
                                        <span>{{ user.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-2"></div>
                                    <div class="col-lg-10">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('users.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveUserAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('users.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="saveUserAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('users.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updateUserAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('users.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updateUser()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('users.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('users.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('users.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   

                                       
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-2"></div>
                                    <div class="col-lg-10">
                                                                             

                                        <!-- ONAYLAMA BUTONLARI -->
                                        <template v-if="!addButtons && (user.status == 'Ödeme Yapıldı Onay Bekliyor' || user.status == 'Eski Üye Olarak Aktarıldı') || user.status == 'Yeni'">  
                                            <b-button
                                                v-if="hasPermission('users.approve')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="approveUser()"
                                            >
                                            <i class="la la-check"></i>
                                                Onayla
                                            </b-button>
                                            
                                        </template>

                                        <template v-if="!addButtons && user.status == 'Aktif'">  
                                            <b-button
                                                v-if="hasPermission('users.expel')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="expelUser()"
                                            >
                                            <i class="la la-check"></i>
                                                İhraç Et
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('users.resign')"
                                                size="sm"
                                                variant="warning"
                                                :disabled="isDisabled"
                                                @click="resignUser()"
                                            >
                                            <i class="la la-check"></i>
                                                İstifa
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('users.death')"
                                                size="sm"
                                                variant="secondary"
                                                :disabled="isDisabled"
                                                @click="deathUser()"
                                            >
                                            <i class="la la-check"></i>
                                                Vefat
                                            </b-button>
                                            
                                        </template>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-2"></div>
                                    <div class="col-lg-10">
                                                                             
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>

                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>

    </div>
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_USER_DATA } from "@/core/services/store/users.module";
import { CREATE_USER } from "@/core/services/store/users.module";
import { UPDATE_USER } from "@/core/services/store/users.module";
import { DELETE_USER } from "@/core/services/store/users.module";
import { APPROVE_USER } from "@/core/services/store/users.module";

import { EXPEL_USER } from "@/core/services/store/users.module";
import { RESIGN_USER } from "@/core/services/store/users.module";
import { DEATH_USER } from "@/core/services/store/users.module";

import { FIND_BY_ROLE_NAME } from "@/core/services/store/roles.module";
import { FIND_BY_PERMISSION_NAME } from "@/core/services/store/permissions.module";
import constants from '@/core/constants/index';
import Multiselect from 'vue-multiselect'


export default {
    name: "users-form",

    data() {
        return {
            dialog: false,
            user:{
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            default_photo: "media/users/blank.png",
            current_photo: null,
            roles: [],
            permissions: [],
            regions: constants.REGIONS,
            blood_groups: constants.BLOOD_GROUPS,
            member_years: constants.MEMBER_YEARS,
            member_statuses: constants.MEMBER_STATUSES
            
        };
    },
   
    methods: {
        saveUserAndGoBack() {
            this.user.photo = this.current_photo;
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(CREATE_USER, {data, goBack})
        },

        saveUserAndAddNew() {
            this.user.photo = this.current_photo;
            const data =  this.user;
            const goBack = false;
            this.$store.dispatch(CREATE_USER, {data, goBack})
        },

        updateUserAndGoBack() {
            this.user.photo = this.current_photo;
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(UPDATE_USER, { data, goBack })
        },

        updateUser() {
            this.user.photo = this.current_photo;
            const data = this.user;
            const goBack = false;
            this.$store.dispatch(UPDATE_USER, { data, goBack })
        },

        deleteUser() {
            var itemToDelete = this.user.id;
            this.$store.dispatch(DELETE_USER, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        approveUser() {
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(APPROVE_USER, { data, goBack })
        },

        expelUser() {
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(EXPEL_USER, { data, goBack })
        },

        resignUser() {
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(RESIGN_USER, { data, goBack })
        },

        deathUser() {
            const data = this.user;
            const goBack = true;
            this.$store.dispatch(DEATH_USER, { data, goBack })
        },

        changeFormToAdding(){
            this.title = "Kullanıcı: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "Kullanıcı: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "Kullanıcı: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        onFileChange(e) {
            const file = e.target.files[0];
            if (typeof FileReader === "function") {
                const reader = new FileReader();

                reader.onload = event => {
                    this.current_photo = event.target.result;
                };

                reader.readAsDataURL(file);
            } else {
                alert("Sorry, FileReader API not supported");
            }
        },

        findByRoleName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_ROLE_NAME, {searchText, x})
                    .then((response) => {
                        this.roles = response.data;
                    })
                }, 500);
            }

            
        },

        findByPermissionName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_PERMISSION_NAME, {searchText, x})
                    .then((response) => {
                        this.permissions = response.data;
                    })
                }, 500);
            }

            
        },

        getClass(status) {
            if (status == "Ödeme Yapıldı Onay Bekliyor") return 'warning'
            if (status == "Eski Üye Olarak Aktarıldı") return 'warning'
            if (status == "Aktif") return 'primary'
            if (status == "İhraç") return 'danger'
            if (status == "İstifa") return 'warning'
            if (status == "Vefat") return 'secondary'
        },
    },


    components: {
        KTCard,
        Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
    
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_USER_DATA, { id })
            .then(( response ) => {
                this.user = response.data;
                if(response.data.user_created != null)
                    {this.user.user_created_name = response.data.user_created_name[0].name;}
                if(response.data.user_updated != null)
                    {this.user.user_updated_name = response.data.user_updated_name[0].name;}
                this.current_photo = this.user.photo
            })
        }
        
        /*window.Echo.channel('App.User.' + this.id)
        .listen('PrivateChannel', (e) => {
            console.log(e);
        });*/

 
    },

    mounted(){
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }

    },

    computed: {
        ...mapGetters(["currentUserMenu" ]),

        ...mapState({
            loading: state => state.users.loading,
            row: state => state.users.row,
            errors: state => state.users.errors,
            isDisabled: state => state.users.isDisabled,
            //user: state => state.users.user_data
        }),

        photo() {
            return this.current_photo == null
                ? this.default_photo
                : this.current_photo;
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}

#kt_profile_avatar { position: relative; }
#kt_profile_avatar .avatar-img {
  width: 125px;       /* Metronic kutu ölçüne göre ayarla */
  height: 125px;
  border-radius: .42rem;
  object-fit: cover;  /* background-size: cover benzeri */
  display: block;
  background: #f3f6f9;
}

</style>
